// extracted by mini-css-extract-plugin
export default {"main_layout":"LayoutNav_main_layout__VEXjU","main_page":"LayoutNav_main_page__SvhqI"};